module.exports = __webpack_public_path__ + "img/pic5.63505cd5.png";